import { createPortal } from 'react-dom';
import { useDragDropContext } from '../context/DragDropContext';

export function DragGhost() {
  const { dragState } = useDragDropContext();
  if (!dragState.isDragging || !dragState.item) return null;

  const { item, x, y } = dragState;

  return createPortal(
    <div
      className="fixed pointer-events-none z-[9999] select-none"
      style={{
        left: x,
        top: y,
        transform: 'translate(-50%, -50%) rotate(4deg) scale(1.1)',
        opacity: 0.85,
      }}
    >
      <div
        className="w-[70px] h-[70px] rounded-md flex flex-col items-center justify-center relative"
        style={{
          background: 'radial-gradient(ellipse at center, #113557 0%, #0a1e35 100%)',
          border: '1px solid #137fe3',
          boxShadow: '0 0 14px rgba(19,127,227,0.5)',
        }}
      >
        <img
          src={item.image}
          alt={item.name}
          className="object-contain pointer-events-none"
          style={{ maxWidth: 49, maxHeight: 35 }}
          draggable={false}
        />
        <span className="absolute bottom-1 left-0 right-0 text-center text-[10px] leading-none text-white pointer-events-none">
          {item.name}
        </span>
      </div>
    </div>,
    document.body,
  );
}
